/**
 * Implement Gatsby's Browser APIs in this file.
 *
 * See: https://www.gatsbyjs.org/docs/browser-apis/
 */

const { setPreviousPages } = require('utils/previous-pages-storage');

require('@fontsource/lato/400.css');
require('@fontsource/lato/700.css');
require('@fontsource/lato/900.css');

// You can delete this file if you're not using it
require('./src/styles/app.scss');

// In production, surface extra context for React hydration errors in the console
if (typeof window !== 'undefined' && process.env.NODE_ENV === 'production') {
  const originalConsoleError = console.error;
  // eslint-disable-next-line no-console
  console.error = (...args) => {
    const [firstArg] = args;
    if (typeof firstArg === 'string' && firstArg.includes('Hydration failed')) {
      // eslint-disable-next-line no-console
      originalConsoleError('Hydration error on route:', window.location.pathname);
    }
    originalConsoleError(...args);
  };
}

// function to jump to the correct scroll position when following a link with a anchor
function scrollToAnchor(location) {
  const { hash } = location;

  if (!hash) return;

  window.onload = function () {
    window.requestAnimationFrame(() => {
      const anchor = document.querySelector(hash);

      if (!anchor) return;

      const offset = anchor.getBoundingClientRect().top + window.scrollY;

      window.scroll({ top: offset });
    });
  };
}

// Inject <link rel="manifest"> lazily after page load to keep it out of the
// critical request chain (fixes Lighthouse "Avoid chaining critical requests").
if (typeof window !== 'undefined') {
  window.addEventListener('load', () => {
    if (!document.querySelector('link[rel="manifest"]')) {
      const link = document.createElement('link');
      link.rel = 'manifest';
      link.href = '/manifest.webmanifest';
      document.head.appendChild(link);
    }
  });
}

exports.onRouteUpdate = ({ location }) => {
  setPreviousPages(location.pathname);
  scrollToAnchor(location);
};

exports.shouldUpdateScroll = ({ routerProps }) => {
  const location = routerProps?.location;
  if (!location) return true;
  if (location.state && location.state.preventScroll === true) {
    return false;
  }
  return true;
};
